import {
	Component,
	EventEmitter,
	Input,
	Output,
	ChangeDetectionStrategy,
} from "@angular/core"
import { ConfigDefinitions, Testschedule } from "@app/definitions/types"
import { Modalable } from "@app/Modalable"
import { ModalService } from "@app/services/modal.service"
import { ValidatorService } from "@app/services/validator.service"
import * as moment from "moment"
import { COMMON_SCHEDULER_IMPORTS } from "./common-scheduler-imports"

@Component({
	selector: "app-scheduler",
	imports: [COMMON_SCHEDULER_IMPORTS],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./scheduler.component.html",
})
export class SchedulerComponent extends Modalable {
	isModalOpen: boolean = false
	@Input() patient_id: number
	isSendingInvite: boolean = false
	isSaving: boolean = false
	data: Testschedule = new Testschedule()
	errors: any = {}
	isFormSubmittable: boolean = true
	hasDaysError: boolean = false
	dayRowsDates: any = {}

	ngOnInit() {
		this.data.start_date = moment
			.utc()
			.format(ConfigDefinitions.momentDateFormat)
	}

	changeInterval() {
		this.data.daysArr = []
		if (this.data.is_fixed_interval === "no") {
			this.addDaysArrRow()
		}
		this.validateEntireForm()
	}

	addDaysArrRow() {
		this.data.daysArr = [
			...this.data.daysArr,
			{
				id: this.data.daysArr.length + 1,
				num: 1,
			},
		]
	}
	handleDateChange() {
		this.validateEntireForm()
	}
	handleDaysArrChange(arr: any[]) {
		this.data.daysArr = arr
		this.validateEntireForm()
	}
	handleDaysError(hasError: boolean) {
		this.hasDaysError = hasError
		this.validateEntireForm()
	}

	validateEntireForm() {
		const baseValiFields: any = {
			start_date: { not_empty: true, today_and_later: true },
		}
		const intervalValiFields: any = {
			interval: { is_positive: true },
			repetitions: { is_positive: true },
		}

		const valiFields =
			this.data.is_fixed_interval === "yes"
				? { ...baseValiFields, ...intervalValiFields }
				: baseValiFields

		this.isFormSubmittable =
			this.validator.validateEntireForm(this.data, this.errors, valiFields) &&
			!this.hasDaysError
	}

	async handleSubmit() {}
	async handleContactwaysClose(arr: any) {}
}
